import { decryptData, encryptData } from "config/config";
import { instance as axios } from "config/axiosInstance";
import { isLoggedIn } from "utils";

// *********************************** Contact List ***********************************************
export const getContactList = async (data) => {
  return decryptData(
    await axios.get(
      `/getContactList?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};


